import AuctionItemDetailsPage from './AuctionItemDetailsPage';

export default AuctionItemDetailsPage;
